import { PageLayout } from 'components/base/layout-components';
import useForecastingTabs from './useForecastingTabs';
import RouterTabs from 'components/RouterTabs';
import FiltersProvider from '../state/filters/FiltersProvider';
import ProjectProgressionProvider from './ProjectProgression/state/Provider';
import useFiltersConfig from './useFiltersConfig/useFiltersConfig';
import useIsForecastingCTA from './useFiltersConfig/useIsForecastingCTA';
import ForecastingCTA from './ProjectProgression/ProjectProgressionCTA';

const ForecastingRouter = () => {
  const isForecastingCTA = useIsForecastingCTA();
  const forecastingTabs = useForecastingTabs();
  const { FiltersBar, FiltersContext } = useFiltersConfig();

  if (isForecastingCTA) return <ForecastingCTA />;
  if (!FiltersContext) return null;

  return (
    <ProjectProgressionProvider>
      <FiltersProvider Context={FiltersContext} withInitialFilters={false}>
        <PageLayout>
          {FiltersBar}
          <RouterTabs
            tabs={forecastingTabs}
            withTabs={forecastingTabs.length > 1}
          />
        </PageLayout>
      </FiltersProvider>
    </ProjectProgressionProvider>
  );
};

export default ForecastingRouter;
